import { z } from 'zod'

// Prize types enum for validation
export const prizeTypeEnum = z.enum(['Product', 'Points', 'Voucher', 'Nothing'])

// Schema for adding a single prize
export const addPrizeSchema = z
  .object({
    prizeType: prizeTypeEnum,
    productId: z.string().optional(),
    pointsAmount: z.number().int().min(1).optional(),
    voucherId: z.string().optional(),
    voucherTypeId: z.string().optional(),
    quantity: z.number().int().min(1, 'Số lượng phải ít nhất là 1'),
    displayName: z.string().min(1, 'Tên giải thưởng là bắt buộc'), // Required field for display name
  })
  // .refine(
  //   (data) => {
  //     if (data.prizeType === 'Product') {
  //       return !!data.productId
  //     }
  //     return true
  //   },
  //   {
  //     message: 'Vui lòng chọn sản phẩm',
  //     path: ['productId'],
  //   }
  // )
  .refine(
    (data) => {
      if (data.prizeType === 'Points') {
        return !!data.pointsAmount && data.pointsAmount > 0
      }
      return true
    },
    {
      message: 'Số điểm phải lớn hơn 0',
      path: ['pointsAmount'],
    }
  )
  .refine(
    (data) => {
      if (data.prizeType === 'Voucher') {
        return !!data.voucherTypeId
      }
      return true
    },
    {
      message: 'Vui lòng chọn voucher type',
      path: ['voucherTypeId'],
    }
  )

export type AddPrizeFormData = z.infer<typeof addPrizeSchema>

// Schema for setting prize probability
export const prizeProbabilityItemSchema = z.object({
  prizeId: z.string(),
  probability: z
    .number()
    .min(0, 'Xác suất không được âm')
    .max(100, 'Xác suất không được vượt quá 100%'),
  displayName: z.string().optional(), // For display
})

export const setPrizeProbabilitiesSchema = z
  .object({
    probabilities: z
      .array(prizeProbabilityItemSchema)
      .min(1, 'Phải có ít nhất 1 giải thưởng'),
  })
  .refine(
    (data) => {
      const total = data.probabilities.reduce(
        (sum, item) => sum + item.probability,
        0
      )
      return Math.abs(total - 100) < 0.01 // Allow small floating point errors
    },
    {
      message: 'Tổng xác suất phải bằng 100%',
      path: ['probabilities'],
    }
  )

export type SetPrizeProbabilitiesFormData = z.infer<
  typeof setPrizeProbabilitiesSchema
>

// Prize with probability (for display in step 3)
export interface PrizeWithProbability {
  id: string
  prizeType: string
  productId?: string
  pointsAmount?: number
  quantity: number
  remainingQuantity: number
  probability: number
  displayName?: string
}
